import Icon, { Icons } from '@/presentation/components/elements/Icon';
import { MutationStatus } from '@tanstack/react-query';

interface RefreshBalancesProps {
  onRefresh: () => void;
  refreshStatus: MutationStatus;
}
export const RefreshBalances = ({
  onRefresh,
  refreshStatus,
}: RefreshBalancesProps) => {
  return (
    <button
      type="button"
      className="md:mr-auto hover:underline text-xs px-2 hover:text-gray-800 text-gray-500 relative inline-flex items-center"
      onClick={onRefresh}
      disabled={refreshStatus === 'loading'}
    >
      <span className={refreshStatus === 'loading' ? 'opacity-50' : ''}>
        {'Refresh balances'}
      </span>
      {refreshStatus === 'loading' && (
        <Icon
          name={Icons.SPINNER_GAP}
          size={20}
          className="animate-spin ml-1"
        />
      )}
    </button>
  );
};
